import { pr, React, theme, ui } from "aaa";
import { SettingsButton } from "components/loginManagement/components/SettingsButton";
import { IconChildren } from "components/util/primitives";
import { themeColors } from "muiTheme";

export const getJuniorValue = (juniorValue: "active" | "tooYoung" | "activationNeeded" | "migrationNeeded" | undefined) => {
    const dark = ui.isDarkMode;

    if (!juniorValue) {
        return {
            color: dark ? theme.themeColors.d_grey_100 : themeColors.grey_400,
            backgroundColor: dark ? theme.themeColors.d_grey_200 : themeColors.grey_100,
            text: ui.__("gJunior.activate.notAvailable"),
        };
    }

    switch (juniorValue) {
        case "active":
            return {
                color: dark ? theme.themeColors.ui_green : themeColors.ui_green,
                backgroundColor: dark ? "rgba(0, 171, 86, 0.22)" : "honeyDew",
                text: ui.__("gJunior.active"),
            };
        case "tooYoung":
            return {
                color: dark ? theme.themeColors.d_grey_100 : themeColors.grey_400,
                backgroundColor: dark ? theme.themeColors.d_grey_200 : themeColors.grey_100,
                text: ui.__("gJunior.activate.notAvailable"),
            };
        case "activationNeeded":
        case "migrationNeeded":
            return {
                color: dark ? theme.themeColors.d_blue_100 : themeColors.blue_300,
                backgroundColor: dark ? "rgba(57, 139, 252, 0.22)" : themeColors.ui_blue_light,
                text: ui.__("gJunior.notActive"),
            };
        default:
            return {
                color: dark ? theme.themeColors.d_grey_100 : themeColors.grey_400,
                backgroundColor: dark ? theme.themeColors.d_grey_200 : themeColors.grey_100,
                text: ui.__("gJunior.unknownStatus"),
            };
    }

};

export const ChildContent = ({
    name,
    juniorValue,
    gender,
    iconOnRight = false
}: {
    name: string;
    juniorValue: "active" | "tooYoung" | "activationNeeded" | "migrationNeeded" | undefined;
    gender: "MALE" | "FEMALE" | "UNKNOWN";
    iconOnRight?: boolean;
}) => {
    const getIconSrc = () => {
        switch (gender) {
            case "MALE":
                return require("../../../../assets/gJunior/child_icon_boy.svg");
            case "FEMALE":
                return require("../../../../assets/gJunior/child_icon_girl.svg");
            default:
                return null; // Will use IconChildren component instead
        }
    };

    const iconSrc = getIconSrc();

    const iconElement = (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: iconOnRight ? 64 : 48,
                height: iconOnRight ? 64 : 48,
                borderRadius: "100%",
                backgroundColor: ui.isDarkMode ? "rgba(25, 156, 249, 0.2)" : themeColors.grey_100
            }}
        >
            {iconSrc ? (
                <img src={iconSrc}
                    style={{
                        width: iconOnRight ? 56 : 40,
                        height: iconOnRight ? 56 : 40,
                        color: ui.isDarkMode ? theme.themeColors.d_blue_100 : themeColors.blue_300,
                        padding: iconOnRight ? 4 : 8
                    }}
                />
            ) : (
                <IconChildren
                    style={{
                        width: iconOnRight ? 56 : 40,
                        height: iconOnRight ? 56 : 40,
                        color: ui.isDarkMode ? theme.themeColors.d_blue_100 : themeColors.blue_300,
                        padding: iconOnRight ? 4 : 8
                    }}
                />
            )}
        </div>
    );

    const textContent = (
        <div style={{ flexGrow: 1, marginLeft: iconOnRight ? 0 : theme.MARGIN, marginRight: theme.MARGIN }}>
            <pr.P_16_TITLE
                style={{
                    flex: 1,
                    fontWeight: 500,
                }}
            >
                {name}
            </pr.P_16_TITLE>

            <pr.P_14_CONTENT style={{
                backgroundColor: getJuniorValue(juniorValue).backgroundColor,
                color: getJuniorValue(juniorValue).color,
                display: "inline-block",
                padding: "4px 8px",
                borderRadius: 16,
                marginTop: 4,
                fontWeight: 500
            }}>
                {getJuniorValue(juniorValue).text}
            </pr.P_14_CONTENT>
        </div>
    );

    return (
        <>
            {iconOnRight ? (
                <>
                    {textContent}
                    {iconElement}
                </>
            ) : (
                <>
                    {iconElement}
                    {textContent}
                </>
            )}
        </>
    );
};

export const JuniorChild = ({
    name,
    juniorValue,
    gender,
    iconOnRight = false,
    onClick,
    isLast = false
}: {
    name: string;
    juniorValue: "active" | "tooYoung" | "activationNeeded" | "migrationNeeded" | undefined;
    gender: "MALE" | "FEMALE" | "UNKNOWN";
    iconOnRight?: boolean;
    onClick?: () => void;
    isLast?: boolean;
}) => (
    <SettingsButton
        border={isLast ? "none" : "bottom"}
        borderRadius="none"
        onClick={onClick}
        style={{ backgroundColor: ui.isDarkMode ? themeColors.d_grey_300 : "white" }}
    >
        <ChildContent
            name={name}
            juniorValue={juniorValue}
            gender={gender}
            iconOnRight={iconOnRight}
        />
        {onClick && <pr.IconChevronRight style={{ color: "#A7B6C7" }} />}
    </SettingsButton>
);


// WEBPACK FOOTER //
// ./src/components/gJunior/components/cards/JuniorChild.tsx